<template>
    <aside class="app-header-contact-area" v-click-outside="hideDropdown">
        <button type="button" class="btn btn--secondary btn--has-icon app-header-contact-area__btn" @click="dropdownVisible = !dropdownVisible">

            <span class="app-header-contact-area__btn-label d-none d-lg-block" v-t="{ path: 'contactArea.btnLabel' }"></span>
        </button>

        <div class="app-header-contact-area__dropdown" v-show="dropdownVisible">
            <div class="app-header-contact-area__dropdown-inner">
                <h4 class="app-header-contact-area__headline" v-t="{ path: 'contactArea.headline' }"></h4>
                <a v-if="hotline" :href="'tel:' + hotline" class="app-header-contact-area__number d-inline-block" v-html="hotline"></a>
                <template v-if="tExists('contactArea.hotlineNote')">
                    <br><small v-t="{ path: 'contactArea.hotlineNote' }"></small>
                </template>
                <template v-else>
                    <br><br>
                </template>
                <template v-if="email">
                    <template v-if="tExists('contactArea.emailLabel')">
                        <span class="app-header-contact-area__email-label h4 d-block" v-t="{ path: 'contactArea.emailLabel' }"></span>
                    </template>
                    <template v-else>
                        <br><br>
                    </template>
                    <a :href="'mailto:' + email" v-html="email" class="d-inline-block"></a>
                </template>
            </div>
        </div>
    </aside>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
    name: 'AppHeaderContactArea',
    directives: {
        ClickOutside
    },
    data: () => ({
        dropdownVisible: false,
        email: process.env.VUE_APP_APP_HEADER_CONTACT_AREA_EMAIL,
        hotline: process.env.VUE_APP_HOTLINE
    }),
    methods: {
        hideDropdown () {
            this.dropdownVisible = false
        }
    }
}
</script>

<style scoped>
    .app-header-contact-area {
        position: relative;
        width: 100%;
        height: 100%;
        border-left: 1px solid #e6e6e6;
    }
    .app-header-contact-area__btn.app-header-contact-area__btn {
        height: 100%;
        padding: 8px 10px;
        border-width: 0;

        display: inline-flex;
        align-items: center;
    }
    .app-header-contact-area__btn.app-header-contact-area__btn:hover,
    .app-header-contact-area__btn.app-header-contact-area__btn:focus {
        color: #f96915;
        background-color: transparent;
    }
    .app-header-contact-area__btn:before {
        content: '\e801';
        font-family: StillShopIcons;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        font-variant: normal;
        text-transform: none;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    .app-header-contact-area__dropdown {
        position: absolute;
        top: 100%;
        right: 0;
        margin: 0 -10px;
        padding: 0 10px 10px;
        overflow: hidden;
    }
    .app-header-contact-area__dropdown-inner {
        padding: 12px;
        background-color: #fff;
        box-shadow: 0 1px 10px 0 rgba(0, 0, 0, .2);
    }
    .app-header-contact-area__headline {
        white-space: nowrap;
        margin-bottom: .2em;
    }
    .app-header-contact-area__number {
        font-size: 1.5em;
        font-weight: 700;
        white-space: nowrap;
        /* no margin-bottom */
    }
    .app-header-contact-area__email-label.app-header-contact-area__email-label {
        margin-bottom: .2em;
    }

    @media ( min-width: 992px ) {
        .app-header-contact-area {
            padding: 10px 15px;
            border-left: 0;
        }
        .app-header-contact-area__btn.app-header-contact-area__btn {
            font-size: 14px;
            border-width: 2px;
        }
        .app-header-contact-area__dropdown {
            right: 15px;
        }
        .app-header-contact-area__dropdown-inner {
            padding: 20px;
        }
        .app-header-contact-area__btn:before {
            margin-right: .6em;
            margin-left: .2em;
        }
    }
</style>
